<div class="auth">
  <header class="auth-header">
    <img src="assets/images/logo.png" alt="SipSignal Efax Logo" class="auth-header-logo" />
  </header>

  <main class="auth-main">
    <h1 class="h2">Verify your email</h1>

    <div class="verify-email-content">
      <p class="verify-email-description">
        Confirm your email to activate your account and get a free 7-day trial subscription
      </p>

      <p *ngIf="!isSendError" class="verify-email-description">A confirmation email has been sent to your inbox:</p>

      <div class="verify-email-address">{{ email }}</div>

      <p *ngIf="isSendError" class="form-error">
        Failed to send confirmation email. Please try again.
      </p>

      <p *ngIf="!isSendError && resendCooldownSeconds > 0" class="verify-email-resend-timer">
        Resend is available via {{ formattedCooldown }}
      </p>

      <button
        *ngIf="isSendError || resendCooldownSeconds <= 0"
        type="button"
        class="btn_primary btn_md verify-email-resend-button"
        (click)="resend()"
      >
        Send again
      </button>
    </div>
  </main>
</div>
